'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ResponsiveImageFACC = require('./ResponsiveImageFACC');

var _ResponsiveImageFACC2 = _interopRequireDefault(_ResponsiveImageFACC);

var _ProgressiveImage = require('./progressiveImages/ProgressiveImage');

var _ProgressiveImage2 = _interopRequireDefault(_ProgressiveImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
// Lib
var ResponsiveProgressiveImage = function ResponsiveProgressiveImage(_ref) {
    var imageType = _ref.imageType,
        imageDetails = _ref.imageDetails,
        alt = _ref.alt,
        size = _ref.size,
        onImageLoadCb = _ref.onImageLoadCb,
        style = _ref.style,
        forcedWidth = _ref.forcedWidth,
        forcedHeight = _ref.forcedHeight;

    var aspectRatio = imageDetails.get('height') / imageDetails.get('width');
    var thumb = imageDetails.get('thumb');
    var transparent = imageDetails.get('transparent');

    return _react2.default.createElement(
        _ResponsiveImageFACC2.default,
        { imageType: imageType, imageDetails: imageDetails, size: size },
        function (imageSource) {
            return _react2.default.createElement(_ProgressiveImage2.default, {
                thumbnail: thumb,
                source: imageSource,
                style: style,
                aspectRatio: aspectRatio,
                onImageLoadCb: onImageLoadCb,
                alt: alt,
                size: size,
                transparent: transparent,
                forcedWidth: forcedWidth,
                forcedHeight: forcedHeight });
        }
    );
};

ResponsiveProgressiveImage.propTypes = {
    imageType: _propTypes2.default.string.isRequired,
    imageDetails: _propTypes2.default.object.isRequired,
    size: _propTypes2.default.number.isRequired,
    onImageLoadCb: _propTypes2.default.func,
    style: _propTypes2.default.object,
    alt: _propTypes2.default.string,
    forcedWidth: _propTypes2.default.number,
    forcedHeight: _propTypes2.default.number
};

exports.default = ResponsiveProgressiveImage;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/images/ResponsiveProgressiveImage.js
// module id = 1901
// module chunks = 0